<div class="widget" [ngClass]="entry.product.status === 'denied' || entry.product.status === 'notinvited' ? 'greyBox' : 'redBox'">
  <span class="widget__text">
    <strong>{{ entry.product.status | productStateTranslate }}</strong>
    <ng-container *ngIf="entry.cycle as cycle">
      in
      <strong [title]="cycle.name">{{ cycle.name }}</strong>
    </ng-container>
  </span>
</div>
